import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { 
  GetUserQueryResponse, 
  GetUsersQueryResponse, 
  CheckUserQuery, 
  CreateUserCommand, 
  UpdateUserCommand, 
  TotalTimeSheetGeneralVM, 
  SalesHoursDaysAllVM, 
  TotalCreamSalesGeneralVM, 
  CreamsSalesDashVM 
} from '../interfaces/interfaces';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiSite.endsWith('/') 
      ? environment.apiSite.slice(0, -1) 
      : environment.apiSite;
  }

  // Get user by ID
  getUser(params: { id: number}): Observable<GetUserQueryResponse> {
    return this.http.get<GetUserQueryResponse>(`${this.baseUrl}/api/Auth/${params.id}`);
  }

  // Get all users
  getAllUsers(): Observable<GetUsersQueryResponse> {
    return this.http.get<GetUsersQueryResponse>(`${this.baseUrl}/api/Auth`);
  }

  // Login user
  login(command: CheckUserQuery): Observable<string> {
    return this.http.post<string>(`${this.baseUrl}/api/Auth/LoginUser`, command);
  }

  // Create user
  createUser(command: CreateUserCommand): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/Auth/CreateUser`, command);
  }

  // Update user
  updateUser(command: UpdateUserCommand): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/api/Auth`, command);
  }

  // Backup database
  backupDB(): Observable<string> {
    return this.http.post<string>(`${this.baseUrl}/api/Auth/BackupDB`, {});
  }

  // Get timesheet dashboard
  getTimeSheetDash(params: { day?: string; dayTo?: string; useDay?: number }): Observable<TotalTimeSheetGeneralVM> {
    return this.http.get<TotalTimeSheetGeneralVM>(`${this.baseUrl}/api/Auth/TimeSheetDash`, { params });
  }

  // Get hours and days sales dashboard
  getHoursAndDaysSalesDash(params: { dayFrom?: string; dayTo?: string; useDay?: number }): Observable<SalesHoursDaysAllVM> {
    return this.http.get<SalesHoursDaysAllVM>(`${this.baseUrl}/api/Auth/HoursAndDaysSalesDash`, { params });
  }

  // Get general sales dashboard
  getGeneralSalesDash(params: { useDay?: number; year?: number }): Observable<TotalCreamSalesGeneralVM> {
    return this.http.get<TotalCreamSalesGeneralVM>(`${this.baseUrl}/api/Auth/GeneralSalesDash`, { params });
  }

  getGeneralSalesDash7Days(params: { day?: string; useDay?: number }): Observable<TotalCreamSalesGeneralVM> {
    return this.http.get<TotalCreamSalesGeneralVM>(`${this.baseUrl}/api/Auth/GeneralSalesDash7Days`, { params });
  }

  // Get creams sales dashboard
  getCreamsSalesDash(): Observable<CreamsSalesDashVM> {
    return this.http.get<CreamsSalesDashVM>(`${this.baseUrl}/api/Auth/CreamsSalesDash`);
  }

  // Get MH sales dashboard
  getMHSalesDash(): Observable<CreamsSalesDashVM> {
    return this.http.get<CreamsSalesDashVM>(`${this.baseUrl}/api/Auth/MHSalesDash`);
  }

  // Delete import
  deleteImport(id: number): Observable<string> {
    return this.http.post<string>(`${this.baseUrl}/api/Auth/DeleteImport/${id}`, {});
  }

  // Import new creams DB
  importNewCreamsDB(): Observable<string> {
    return this.http.post<string>(`${this.baseUrl}/api/Auth/ImportNewCreamsDB`, {});
  }
}
